import { useState } from "react";
import { useAuth } from "../auth/AuthContext.js";
import { resolveRecordAccess, type RecordAccess } from "./record-state.js";

export function useRecordAccess(closed: boolean): RecordAccess {
    const { user } = useAuth();
    const [unlocked, setUnlocked] = useState(false);
    const { canUnlock, ...access } = resolveRecordAccess(user?.role, closed, unlocked);
    return { ...access, unlock: canUnlock ? () => setUnlocked(true) : undefined };
}
